import {useQuery } from "@tanstack/react-query";
import {getRedeemptionReport} from "../../service/query/auth";

export const useGetRedeemptionReport = ({ payload, page }) => {
  const getAllRedeemptionReport= useQuery({
    queryKey: ['redeemptionReport', payload, page],
    queryFn: () => getRedeemptionReport({ ...payload, page }),
    enabled: !!payload && !!page,
    keepPreviousData: true,
  },
);
  return {data:getAllRedeemptionReport?.data?.data,  ...getAllRedeemptionReport,}
};